import { h, Host } from "@stencil/core";
export class ChatTypingIndicator {
    constructor() {
        this.text = undefined;
    }
    render() {
        return (h(Host, { key: '03791b0809cc34939bce0aae8d95b1bf48709846' }, h("ux-copy", { key: '9205155d9de020a31e2960e420c25a6a9e3a170e', variant: "default" }, this.text, h("span", { key: '0d97f2096a82d56e3687981c64a32bfcbc6b2aa3', class: "typing-dots" }, h("span", { key: 'ea956204be5f3c1178b2b27a185a8472c6bb3910', class: "dot" }), h("span", { key: 'b7eb0993457dc2134aff9ec58ca290b1d99fc353', class: "dot" }), h("span", { key: '2244323a4b80a5dedb4f6fea8baa9a5714a8e8a6', class: "dot" })))));
    }
    static get is() { return "ux-chat-typing-indicator"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["chat-typing-indicator.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["chat-typing-indicator.css"]
        };
    }
    static get properties() {
        return {
            "text": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "The text to show before the typing indicator dots"
                },
                "attribute": "text",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=chat-typing-indicator.js.map
